import { API_BASE_URL } from '../api';

// One turn with the assistant, streamed. The server writes `data: {json}`
// lines; this reads them as they arrive and hands each event to onEvent.
// Plain fetch, because EventSource cannot POST, and the session cookie goes
// along with credentials: 'include'.
export async function streamChat({ messages, context, today, signal, onEvent }) {
  const res = await fetch(`${API_BASE_URL}/assistant/chat`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    // proposal_lines: show a line while a proposal is being written; this
    // client knows the 'settled' status that clears it.
    body: JSON.stringify({ messages, context, today, features: ['proposal_lines'] }),
    signal,
  });
  if (!res.ok) {
    let message = 'The assistant is unavailable right now.';
    try { const body = await res.json(); if (body && body.error) message = body.error; } catch (e) { /* no body */ }
    throw new Error(message);
  }
  if (!res.body) throw new Error('The assistant did not answer.');
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  const handle = (chunk) => {
    for (const line of chunk.split('\n')) {
      if (!line.startsWith('data: ')) continue;
      try { onEvent(JSON.parse(line.slice(6))); } catch (e) { /* a torn line; the next chunk completes it */ }
    }
  };
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf('\n\n')) >= 0) {
      handle(buffer.slice(0, idx));
      buffer = buffer.slice(idx + 2);
    }
  }
  if (buffer.trim()) handle(buffer);
}
